import { createApp } from 'vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import App from './App.vue';
import '../assets/main.css';
import { i18n } from '../i18n';
import { pinia } from './pinia';
import router from './router';

const app = createApp(App);

app.use(router);
app.use(i18n, { inject: true });
app.use(pinia);
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  },
});

app.mount('#app');
